import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "account__wrapper"
}
const _hoisted_2 = { class: "list__content" }
const _hoisted_3 = {
  key: 1,
  class: "list__info list__noinfo"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountLeft = _resolveComponent("AccountLeft")!
  const _component_FindWord = _resolveComponent("FindWord")!
  const _component_WordsTable = _resolveComponent("WordsTable")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_account_making_words = _resolveComponent("account-making-words")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "account",
            onMousedown: _cache[2] || (_cache[2] = ($event: any) => ($setup.setOpenPanel(-1)))
          }, [
            _createVNode(_component_AccountLeft),
            ($setup.currentWords != null && $setup.currentWords?.length > 0 && !$setup.isPushingWord)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "list",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setOpenPanel(-1)))
                }, [
                  _createVNode(_component_FindWord, {
                    onEditPage: $setup.editPage,
                    onFindItem: $setup.findWord
                  }, null, 8, ["onEditPage", "onFindItem"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_WordsTable, {
                      "words-array": $setup.reverseWords[$setup.wordsIndex],
                      index: $setup.wordsIndex,
                      "is-open-panel": $setup.isOpenPanel.value,
                      onSetOpenPanel: $setup.setOpenPanel
                    }, null, 8, ["words-array", "index", "is-open-panel", "onSetOpenPanel"])
                  ]),
                  _createVNode(_component_Paginator, {
                    onNextPage: $setup.nextPage,
                    onPreviousPage: $setup.previousPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_pagination, {
                        modelValue: $setup.wordsIndex,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => (($setup.wordsIndex) = $event)),
                          $setup.editPage
                        ],
                        pages: $setup.reverseWords.length - 1,
                        "range-size": 1,
                        "active-color": "#dddddd"
                      }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["onNextPage", "onPreviousPage"])
                ]))
              : (($setup.currentWords == null || $setup.currentWords?.length > 0) && !$setup.isPushingWord)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("p", null, _toDisplayString($setup.t("account.notList")), 1)
                  ]))
                : ($setup.isPushingWord && $setup.isMyUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_account_making_words)
                    ]))
                  : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoader)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : (_openBlock(), _createBlock(_component_Loader, { key: 2 }))
  ], 64))
}